import React, { lazy, Suspense } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Loading from 'components/shared-components/Loading';
import { APP_PREFIX_PATH } from 'configs/AppConfig'

export const AppViews = () => {
  return (
    <Suspense fallback={<Loading cover="content"/>}>
      <Switch>
        <Route path={`${APP_PREFIX_PATH}/select-control`} component={lazy(() => import(`./select-control`))} />
        <Route path={`${APP_PREFIX_PATH}/home`} component={lazy(() => import(`./home`))} />
        <Route path={`${APP_PREFIX_PATH}/list`} component={lazy(() => import(`./list`))} />
        <Route path={`${APP_PREFIX_PATH}/mylist`} component={lazy(() => import(`./mylist`))} />
        <Route path={`${APP_PREFIX_PATH}/ending`} component={lazy(() => import(`./ending`))} />
        <Route path={`${APP_PREFIX_PATH}/document`} component={lazy(() => import(`./document`))} />
        <Redirect from={`${APP_PREFIX_PATH}`} to={`${APP_PREFIX_PATH}/list`} />
      </Switch>
    </Suspense>
  )
}

export default React.memo(AppViews);
